onComplete(function () {
	// Add code here.

	// scroll

	window.addEventListener('scroll', () => {
		const scroll = window.pageYOffset || document.documentElement.scrollTop;
		const navHeader = document.querySelectorAll('.nav-header');
		if (scroll >= 100) {
			navHeader.forEach(el => el.classList.add('scroll'));
		} else {
			navHeader.forEach(el => el.classList.remove('scroll'));
		}
	})
});